import { useState } from "react";
import { Modal } from "react-bootstrap";
import PrimaryButton from "../../../../../../sharedComponents/primaryButton/PrimaryButton";

function EmployeeWorkTimeDetails({ shifts }) {
    const [show, setShow] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const calculatePerEmployee = () => {
        const employeeMap = {};

        shifts.forEach(shift => {
            if (shift.duration_working && shift.duration_in_pause && shift.employee) {
                const id = shift.employee.id;
                if (!employeeMap[id]) {
                    employeeMap[id] = {
                        firstName: shift.employee.first_name,
                        lastName: shift.employee.last_name,
                        workMinutes: 0,
                        pauseMinutes: 0
                    };
                }
                employeeMap[id].workMinutes += shift.duration_working.hours * 60 + shift.duration_working.minutes;
                employeeMap[id].pauseMinutes += shift.duration_in_pause.hours * 60 + shift.duration_in_pause.minutes;
            }
        });

        return Object.values(employeeMap);
    };

    const employees = calculatePerEmployee();

    return (
        <>
            <PrimaryButton text="Details pro Mitarbeiter" onClick={handleShow} />

            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={true} size="lg">
                <Modal.Header>
                    <Modal.Title>Summen pro Mitarbeiter</Modal.Title>
                    <button type="button" className="close" aria-label="Close" onClick={handleClose}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    {employees.length === 0 ? (
                        <p>Es sind keine Arbeitszeiten vorhanden.</p>
                    ) : (
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "left", padding: "8px" }}>Mitarbeiter</th>
                                    <th style={{ textAlign: "left", padding: "8px" }}>Arbeitszeit</th>
                                    <th style={{ textAlign: "left", padding: "8px" }}>Pausenzeit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {employees.map(emp => {
                                    const workHours = Math.floor(emp.workMinutes / 60);
                                    const workMinutes = emp.workMinutes % 60;
                                    const pauseHours = Math.floor(emp.pauseMinutes / 60);
                                    const pauseMinutes = emp.pauseMinutes % 60;

                                    return (
                                        <tr key={emp.firstName + emp.lastName}>
                                            <td style={{ padding: "8px" }}>
                                                {emp.firstName} {emp.lastName}
                                            </td>
                                            <td style={{ padding: "8px" }}>
                                                {workHours.toString().padStart(2, "0")} Std. {workMinutes.toString().padStart(2, "0")} Min.
                                            </td>
                                            <td style={{ padding: "8px" }}>
                                                {pauseHours.toString().padStart(2, "0")} Std. {pauseMinutes.toString().padStart(2, "0")} Min.
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <PrimaryButton text="Schließen" onClick={handleClose} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default EmployeeWorkTimeDetails;